import { render, staticRenderFns } from "./SynchronizeNews.vue?vue&type=template&id=11c3b7a4"
import script from "./SynchronizeNews.vue?vue&type=script&lang=js"
export * from "./SynchronizeNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports